import { Form, Input, InputNumber, message, Modal, Select, Spin } from "antd";
import { useEffect, useState } from "react";
import { fmtDate, fmtSyma } from "@/extensions/utils";
import { serverFetch } from "@/server";

const ReestrCnt = ({ reestrId, id, onClose }) => {
  const [form] = Form.useForm();
  const [item, setItem] = useState();
  const [loading, setLoading] = useState(false);
  const isNew = !id;
  const showPaymentInfo = !isNew && item?.paymentId;
  const vid = Form.useWatch("vid", form);
  const syma = Form.useWatch("syma", form);
  const saveDisabled = !vid || syma === undefined || syma === null;

  useEffect(() => {
    if (isNew) {
      const newCnt = { reestrId, vid: 1 };
      setItem(newCnt);
      form.setFieldsValue(newCnt);
      return;
    }

    setLoading(true);
    serverFetch(`Reestr/Cnt/${id}`)
      .then(data => {
        setItem(data);
        form.setFieldsValue(data);
      })
      .catch(e => {
        message.error(e.userMessage);
        onClose(false);
      })
      .finally(() => setLoading(false));
  }, [id, reestrId, isNew, form, onClose]);

  const onSave = () => {
    form.validateFields()
      .then(values => {
        const bodyData = { ...item, ...values, reestrId };
        serverFetch("Reestr/Cnt", { method: isNew ? "POST" : "PUT", bodyData })
          .then(() => {
            message.success(isNew ? "Строка добавлена" : "Строка сохранена");
            onClose(true);
          })
          .catch(e => message.error(e.userMessage));
      });
  };

  return (
    <Modal title="Строка реестра" open onOk={onSave} onCancel={() => onClose(false)} okText="OK" cancelText="Отмена" okButtonProps={{ disabled: saveDisabled }}>
      <Spin spinning={loading}>
        <Form form={form} layout="vertical">
          {showPaymentInfo && (
            <div style={{ marginBottom: 16 }}>
              <div><b>Платеж-основание</b></div>
              <div>#: {item.paymentId}</div>
              <div>Дата: {fmtDate(item.paymentDocDate)}</div>
              <div>Вид платежа: {item.paymentVidName}</div>
              <div>Сумма платежа: {fmtSyma(item.paymentSyma)}</div>
              <div>Услуга - основание: {item.productName || ""}</div>
            </div>
          )}
          <Form.Item label="Вид" name="vid" rules={[{ required: true, message: "Укажите вид строки" }]}>
            <Select options={[{ value: 1, label: "Оплата" }, { value: 2, label: "Возврат" }]} />
          </Form.Item>
          <Form.Item label="Сумма" name="syma" rules={[{ required: true, message: "Укажите сумму" }]}>
            <InputNumber precision={2} style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item label="Комментарий" name="comment">
            <Input maxLength={255} />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};

export default ReestrCnt;
